import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-foot',
    templateUrl: './foot.component.html',
    styleUrls: ['./foot.component.scss'],
    standalone: false
})
export class FootComponent implements OnInit {

  year: string;

  constructor() { }

  ngOnInit() {
    this.year = (new Date()).getFullYear().toString();
  }

}
